import React from "react";
import Routes from "./Routes";
import reactDom from "react-dom";

reactDom.render(<Routes/> , document.getElementById("root"))